<template>
  <div class="items" v-if="display_style == 1">
    <el-collapse class="chapter-collapse">
      <!-- :title="chapter.title" -->
      <el-collapse-item :id="'chapter-' + chapter.id" v-for="chapter in chapters" :key="chapter.id">
        <template slot="title">
          <div class="chapter-collapse-title">
            <span class="show-name">{{ chapter.title }}</span>
            <span class="show-count">含{{ chapter.periods.length }}节课</span>
          </div>
        </template>
        <div
          class="chapter-content"
          v-for="period in chapter.periods"
          :key="period.id"
          style="display: block"
        >
          <CoursePeriod
            :period="period"
            :course="course"
            :tryText="tryText"
            :isVideo="isVideo"
            :onPeriodTap="onPeriodTap"
          ></CoursePeriod>
        </div>
      </el-collapse-item>
    </el-collapse>

    <!-- <li
      :id="'chapter-' + chapter.id"
      class="chapter-item"
      v-for="chapter in chapters"
      :key="chapter.id"
      :class="{ 'chapter-expand': chapterExpand[chapter.id] }"
    >
      <div
        class="chapter-title"
        :class="{ 'chapter-title-expand': chapterExpand[chapter.id] }"
        @click="toggleExpand(chapter.id)"
        :title="chapter.title"
      >
        {{ chapter.title }}
      </div>
      <template v-if="chapter.periods">
        <div
          class="chapter-content"
          v-for="period in chapter.periods"
          :key="period.id"
          :class="{ current: currentPeriod == period.id }"
        >
          <CoursePeriod
            :period="period"
            :course="course"
            :tryText="tryText"
            :isVideo="isVideo"
            :onPeriodTap="onPeriodTap"
          ></CoursePeriod>
        </div>
      </template>
    </li> -->
  </div>
  <div class="chapter-periods" v-else>
    <div
      class="chapter-content chapter-content-alone"
      :class="{ current: currentPeriod == period.id }"
      v-for="period in periods"
      :key="period.id"
      style="display: block"
    >
      <CoursePeriod
        :period="period"
        :course="course"
        :tryText="tryText"
        :isVideo="isVideo"
        :onPeriodTap="onPeriodTap"
      ></CoursePeriod>
    </div>
  </div>
</template>
<script>
import CoursePeriod from './CoursePeriod.vue';
import util from '@/utils/plugins';
export default {
  name: 'CourseChapter',
  components: {
    CoursePeriod,
  },
  data() {
    return {
      id: '',
      type: 0,
      chapters: [],
      periods: [],
      chapterExpand: {},
      display_style: 0,
    };
  },
  props: {
    course: {
      type: Object,
    },
    currentPeriod: {
      type: String,
    },
    tryText: {
      type: String,
      default: '试看',
    },
    // 是否来自点播页面
    isVideo: {
      type: Boolean,
      default: false,
    },
    onPeriodTap: {
      type: Function,
    },
  },
  async created() {
    await this.getData();
  },
  watch: {
    course: async function () {
      await this.getData();
    },
  },
  methods: {
    async getData() {
      this.id = this.course.course_id || this.course.id;
      this.type = this.course.course_type;
      await this.getChapter();
      // if (this.currentPeriod) {
      //   this.chapters.forEach((c) => {
      //     if (!c.child) {
      //       return;
      //     }
      //     c.child.forEach((p) => {
      //       if (p.id == this.currentPeriod) {
      //         this.chapterExpand[c.id] = 1;
      //       }
      //     });
      //   });
      // }
    },
    formatPeriod(period) {
      let teacherNames = [];
      if (period.teachers) {
        // period.teachers.forEach(t => {
        //   teacherNames.push(t.teacher_name);
        // });
        teacherNames = period.teachers;
      }
      period.teacher_name = teacherNames.join(',');
      let files = [];
      if (period.datum && period.datum.length > 0) {
        period.datum.forEach((item) => {
          files.push({
            file_name: item.file_name,
            datum_id: item.datum_id,
            fid: item.fid.split(';'),
            file_ext: util.getFileType(item.file_name),
          });
        });
      }
      period.files = files;
    },
    async getChapter() {
      if (!this.id) {
        return;
      }
      if (this.type == 9 || this.course.type == 4) {
        return;
      }
      // let chapters = await this.$http.post('/api/app/courseChapter', {
      //   id: this.id,
      // });
      const resData = await this.$http.post('/api/app/courseChapter/v2', {
        id: this.id,
      });
      let { chapters, periods, is_show_chapter } = resData;
      this.display_style = is_show_chapter;
      if (!this.display_style) {
        if (!periods[0]?.periods_title) {
          // this.display_style = 1;
          periods.forEach((c) => {
            // this.$set(this.chapterExpand, c.id, 0);
            if (!c.periods) {
              return;
            }
            c.periods.forEach((child) => {
              this.formatPeriod(child);
            });
          });
        } else {
          if (this.type != 3) {
            periods = periods.filter((c) => c.parent_id != 0);
          }
          periods.forEach((c) => {
            this.formatPeriod(c);
          });
        }
        this.periods = periods;
      } else {
        if (chapters[0] && chapters[0].periods[0] && !chapters[0].periods[0].periods_title) {
          // this.display_style = 1;
          chapters.forEach((c) => {
            if (!c.periods) {
              return;
            }
            c.periods.forEach((p) => {
              this.formatPeriod(p);
            });
          });
        } else {
          if (this.type != 3) {
            // periods = periods.filter((c) => c.parent_id != 0);
            chapters.forEach((c) => {
              c.periods = c.periods.filter((p) => p.parent_id != 0);
            });
          }
          chapters.forEach((c) => {
            if (!c.periods) {
              return;
            }
            c.periods.forEach((p) => {
              this.formatPeriod(p);
            });
          });
        }
        this.chapters = chapters;
      }
    },
    toggleExpand(id) {
      for (let key in this.chapterExpand) {
        if (key == id) {
          continue;
        }
        this.chapterExpand[key] = 0;
      }
      if (this.chapterExpand[id] == 0) {
        this.chapterExpand[id] = 1;
      } else {
        this.chapterExpand[id] = 0;
      }
      this.$emit('chapterClick', id);
    },
    getNextPeriod(id) {
      let chapters = this.chapters;
      if (!chapters[0].periods_title) {
        chapters = chapters.filter((c) => c.child && c.child.length > 0);
        let c, p;
        let chapter;
        for (c = 0; c < chapters.length; c++) {
          chapter = chapters[c];
          if (!chapter.child) {
            return;
          }
          for (p = 0; p < chapter.child.length; p++) {
            let period = chapter.child[p];
            if (period.id == id) {
              break;
            }
          }
          if (p == chapter.child.length) {
            continue;
          }
          let nextPeriod = chapter.child[p + 1];
          if (nextPeriod) {
            return nextPeriod;
          }
          let nextChapter = chapters[c + 1];
          if (!nextChapter) {
            return;
          }
          return nextChapter.child[0];
        }
      } else {
        let i;
        for (i = 0; i < chapters.length; i++) {
          let chapter = chapters[i];
          if (chapter.id == id) {
            break;
          }
        }
        return chapters[i + 1];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/varibles.scss';
::v-deep {
  .chapter-collapse {
    border: none;
    .chapter-collapse-title {
      margin-right: 8px;
      display: flex;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      .show-name {
        font-family: 'PingFang SC';
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
        color: #1d1b20;
      }
      .show-count {
        color: #54535c;
        font-family: 'PingFang SC';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
    }
    .el-collapse-item__header {
      height: auto;
      line-height: 0;
      border-bottom: none;
    }
    .el-collapse-item {
      padding: 16px;
      box-shadow: 0px 2px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08);
      border: 1px solid #f1f3f9;
      border-radius: 8px;
      margin-bottom: 24px;
    }
    .el-collapse-item:last-child {
      margin-bottom: 0;
    }
    .el-collapse-item__wrap {
      padding-top: 16px;
      padding-left: 12px;
      border-bottom: none;
    }
    .el-collapse-item__arrow {
      margin-right: 0;
      &::before {
        content: '';
        width: 16px;
        height: 16px;
        display: inline-block;
        background: url('~@stu/images/collapse-down.png');
        background-size: cover;
      }
    }
    .el-collapse-item__arrow.is-active {
      -webkit-transform: rotate(-180deg);
      transform: rotate(-180deg);
      transform-origin: center;
    }
  }
}

.items {
  overflow: hidden;
}

.chapter-title {
  height: 58px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 58px;
  padding: 0 34px 0 20px;
  cursor: pointer;
  position: relative;
  margin-bottom: 27px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &::after {
    position: absolute;
    content: '';
    width: 20px;
    height: 12px;
    top: 23px;
    right: 20px;
    background-size: 100% 100%;
    background-image: url('~@/assets/images/video/down@3x.png');
  }

  &.chapter-title-expand::after {
    background-image: url('~@/assets/images/video/up@3x.png');
  }
}

.chapter-content {
  display: none;
  margin-bottom: 24px;
  border-bottom: 1px solid #f3f3f3;
  padding-left: 0;
  padding-bottom: 24px;
  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 24px;
  }

  &.chapter-content-alone {
    // padding-left: 0;
    // padding-bottom: 24px;
    &:first-child {
      padding-top: 24px;
    }

    // &:last-child {
    //   padding-bottom: 24px;
    // }

    ::v-deep {
      .period-point {
        margin-right: 10px;
      }

      .period-file {
        padding-left: 14px;
      }
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.chapter-expand .chapter-content {
  display: block;
}

.chapter-item {
  margin: 0 25px 40px 25px;

  &:first-child {
    margin-top: 25px;
  }
}

.chapter-periods {
  padding-bottom: 32px;
  .chapter-content {
    margin-left: 25px;
    margin-right: 25px;
  }
}
</style>
